





































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Sms extends Vue {
  @Prop(String) readonly type!: string

  public otp: string = ''
  public $refs!: {
    [key: string]: any
  }

  // noinspection JSUnusedLocalSymbols
  private startCountdown() {
    // noinspection TypeScriptValidateJSTypes
    this.$refs[this.type].startCountdown(true)
    this.otp = ''
    this.$emit('requestOtpAgain', { otpValue: this.otp, type: this.type })
  }
}
